import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import Breadcrumb from "./../shared/breadcrumbs";
import { HeroImage } from "../shared/hero-image";
import { PGAdwithAd } from "../../../../rows/ad-free";
import styles from "../text-story-page/styles.m.css";
import StoryMidPromotion from "../../storyMidContent";
import stylesPhoto from "./styles.m.css";
import { ScrollPercentage } from "react-scroll-percentage";

import Media from "react-media";
import { Link } from "@quintype/components";
import Icon from "../../../../atoms/icon";
import { fetchvuuklegetCommentCount } from "../../../../../api";

function PhotoStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderarticleFooter = get(props, ["renderarticleFooter"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const [userType, setUserType] = useState("F");
  const storyId = get(props, ["story", "id"], "");
  const GetStoryScrollPercentage = get(props, ["GetStoryScrollPercentage"], () => null);

  const renderHeaderPhoto = () => (
    <HeroImage story={props.story} className={stylesPhoto["hero-image"]} icon="album" headline="Photo Story" />
  );

  const storyHeadline = get(props, ["story", "subheadline"], () => null);

  const singleCard = get(props, ["story", "cards"], null);
  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;

  const expandComments = get(props, ["expandComments"], () => null);
  const [commentsCount, setCommentsCount] = useState(null);

  // const [showIplArticleBanner, setShowIplArticleBanner] = useState(false);
  const [Percentage, setPercentage] = useState(0);

  // useEffect(() => {
  //   const checkDomain = () => {
  //     const allowedDomain = "sports.vikatan.com";
  //     const hostname = global.location.hostname || "";
  //     setShowIplArticleBanner(hostname === allowedDomain);
  //   };

  //   checkDomain();
  // }, []);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);

  useEffect(
    () => {
      GetStoryScrollPercentage(Percentage);
    },
    [Percentage]
  );

  useEffect(() => {
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        setCommentsCount(res.data);
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }, []);

  const [showShare, setShowShare] = useState(false);

  const handleShareClick = () => {
    setShowShare(!showShare);
  };

  const scrollToComments = () => {
    expandComments();
    const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
    if (commentsWidgetContainer) {
      commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const iplArticleBanner = showIplArticleBanner ? (
  //   <div className={styles["ipl-article-banner"]}>
  //     <div className="hidden-mobile">
  //       <a href="https://sports.vikatan.com/olympics?utm_source=story_banner" rel="noopener noreferrer" target="_blank">
  //         <img
  //           src="https://media.vikatan.com/vikatan/2024-08/b7ae3920-036e-448a-91a2-de23e2c8021e/Vikatan_Sathya_Paris_olympics_article_top_banner_700x120.png"
  //           alt=""
  //         />
  //       </a>
  //     </div>
  //     <div className="hidden-desktop">
  //       <a href="https://sports.vikatan.com/olympics?utm_source=story_banner" rel="noopener noreferrer" target="_blank">
  //         <img
  //           src="https://media.vikatan.com/vikatan/2024-08/b7ae3920-036e-448a-91a2-de23e2c8021e/Vikatan_Sathya_Paris_olympics_article_top_banner_375x120.png"
  //           alt=""
  //         />
  //       </a>
  //     </div>
  //   </div>
  // ) : null;

  return (
    <div className="page-content">
      <div className={`container ${styles["story-grid"]}`}>
        <div className={`${styles["main-content"]} ${stylesPhoto["main-content"]}`}>
          <article className={`${styles["story-body"]} js-story`}>
            {/* <div>{iplArticleBanner}</div> */}
            <Breadcrumb subSection={section} config={props.config} />
            <ScrollPercentage>
              {({ percentage, ref }) => {
                const percentageRound = percentage.toFixed(2) * 100;
                if (percentageRound) {
                  setPercentage(percentageRound);
                }
                return (
                  <div ref={ref}>
                    {renderHeaderCard({ className: stylesPhoto["story-header"] }, true, true)}
                    {renderHeaderPhoto()}
                    <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>

                    <div className={styles["audio-share-wrapper"]}>
                      <div className={styles["audio-comments-share"]}>
                        <div>
                          <Link
                            href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles["box-div"]}
                          >
                            <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                            <span className={styles["channel-txt"]}>Join Our Channel</span>
                          </Link>
                          {/* <Link
                    href="https://bit.ly/3J0OoJc"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                    style={{ padding: "0" }}
                  >
                    <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                  </Link> */}
                        </div>

                        <div className={styles["box-div"]} onClick={scrollToComments}>
                          <Icon type="comment" />
                          <span className={styles["channel-txt"]}>
                            {commentsCount !== null ? commentsCount[storyId] || 0 : 0}
                          </span>
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                        </div>
                        <div
                          className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                          onClick={handleShareClick}
                        >
                          <Icon type="socialshare" />
                          <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                        </div>
                      </div>

                      <div className={styles["social-share-wrapper"]}>
                        {showShare && !readMore && renderSocialMedia("", false)}
                      </div>
                    </div>

                    <div className="vikatan-top-ad-width ad">
                      <div className="ad-container vikatan-top-ad">
                        <Media query="(max-width:768px)">
                          {matches =>
                            matches ? (
                              <div
                                className={`mobile ${
                                  userType === "P" || userType === "T" || userType === "R" ? "" : "ad_300_250"
                                }`}
                              >
                                <PGAdwithAd
                                  adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                                  adSize={[[336, 280], [300, 250]]}
                                  minHeight={280}
                                  adDivId={`div-ad-desk-3849069-169028`}
                                  class="ad_300_250"
                                />
                              </div>
                            ) : null
                          }
                        </Media>
                      </div>
                    </div>
                    {cards &&
                      cards.map((card, index) => {
                        return (
                          <React.Fragment key={card.id}>
                            {index === 1 && (
                              <div>
                                <StoryMidPromotion story={props.story} />
                              </div>
                            )}

                            <div className="story-photo-card">
                              <StoryCard card={card} story={props.story} showCard={readMore} config={props.config} />
                            </div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                );
              }}
            </ScrollPercentage>
            <div id="commentsWidgetContainer">{renderarticleFooter(readMore)}</div>

            <div id="we-story-end" />
          </article>
          {renderFooter(readMore)}
        </div>
        {renderSidebar()}
      </div>
    </div>
  );
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
PhotoStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { PhotoStory };
